module.exports = __webpack_public_path__ + "img/shot_img112802.8d0f6b99.gif";